import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'app-input',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true
    }
  ],
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.css']
})
export class InputComponent implements ControlValueAccessor {
  @Input() id = `input-${Math.random().toString(36).substring(2, 9)}`;
  @Input() type = 'text';
  @Input() label = '';
  @Input() placeholder = '';
  @Input() icon?: string;
  @Input() error?: string;
  @Input() hintText?: string;
  @Input() readonly = false;

  value: string = '';
  disabled: boolean = false;
  showPassword = false;

  onChange: any = () => { };
  onTouched: any = () => { };

  get currentType() {
    if (this.type === 'password') {
      return this.showPassword ? 'text' : 'password';
    }
    return this.type;
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  writeValue(val: string): void {
    this.value = val;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.value = inputElement.value;
    this.onChange(this.value);
  }

  getInputClasses(): string {
    let classes = 'block w-full sm:text-sm rounded-lg border-slate-300 transition-colors focus:ring-secondary focus:border-secondary py-2';

    if (this.icon) classes += ' pl-10';
    else classes += ' pl-3';

    if (this.error) {
      classes += ' border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-10';
    } else {
      classes += ' border-slate-300 text-slate-900 placeholder-slate-400';
    }

    if (this.disabled || this.readonly) {
      classes += ' bg-slate-50 text-slate-500 cursor-not-allowed';
    } else {
      classes += ' bg-white';
    }

    return classes;
  }
}
